<template src="./VerEncuentrosSeguimientos.html"></template>

<script>
import VerEncuentrosExistentes from "../VerEncuentrosExistentes/VerEncuentrosExistentes";
import VerSeguimientoPaciente from "../Seguimiento/VerSeguimientoPaciente/VerSeguimientoPaciente";
import VerGestionOrdenes from "../VerGestionOrdenes/VerGestionOrdenes";
  export default {
    name: "ver-encuentros-seguimientos",
    data() {
      return {
        
      }
    },
    props: {
      deshabilitado: {
        type: Boolean,
        default: false
      },
      verComponente: {
        type: String,
        default: null
      }
    },
    components: {
      VerEncuentrosExistentes,
      VerSeguimientoPaciente,
      VerGestionOrdenes
    }
  }
</script>

<style lang="scss" src="./VerEncuentrosSeguimientos.scss" scoped></style>


// WEBPACK FOOTER //
// src/components/VerEncuentrosSeguimientos/VerEncuentrosSeguimientos.vue